import { render, staticRenderFns } from "./Ellipsis.vue?vue&type=template&id=6e5a590b&scoped=true&"
import script from "./Ellipsis.vue?vue&type=script&lang=js&"
export * from "./Ellipsis.vue?vue&type=script&lang=js&"
import style0 from "./Ellipsis.vue?vue&type=style&index=0&id=6e5a590b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5a590b",
  null
  
)

export default component.exports